/**
 * Query params shared by the account-wide token directory endpoints: `page`
 * and `perPage` mapped to the API's `page`/`per_page`, plus an optional
 * `status` filter.
 *
 * @param {{page?: number, perPage?: number, status?: string}} params
 */
export function paginatedDirectoryParams({ page, perPage, status } = {}) {
    return { page, per_page: perPage, status }
}
